import { FilterAttributes } from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import { Filter } from 'aqTypes';

type MaybeBackboneFilter = FilterAttributes | Filter;

/**
 * Converting MaybeBackboneFilter to pure data recursively.
 * Backbone models have now immutable data structure, so it is safe to work with
 * attributes directly.
 */
export const backboneFilterToFilterAttributes = (
  candidate: MaybeBackboneFilter
): FilterAttributes => {
  const attributes =
    'attributes' in candidate && candidate.attributes
      ? candidate.attributes
      : candidate;
  // Taking attributes from a BackboneFilter we risk having nested rules
  // of type BackboneFilters
  if (attributes && attributes.rules) {
    return {
      ...attributes,
      rules: attributes.rules.map(backboneFilterToFilterAttributes),
    };
  }
  return attributes;
};

export function maybeBackboneFiltersToPureData(filters: {
  advancedFilters: MaybeBackboneFilter[];
  workspaceFilter: MaybeBackboneFilter | null;
}): {
  advancedFilters: FilterAttributes[];
  workspaceFilter: FilterAttributes | null;
} {
  return {
    workspaceFilter: removeBackboneContextFromBackboneFilter(
      filters.workspaceFilter
    ),
    advancedFilters: filters.advancedFilters
      .map(removeBackboneContextFromBackboneFilter)
      .filter(isTruthy),
  };
}

const removeBackboneContextFromBackboneFilter = (
  filter: MaybeBackboneFilter | null
): FilterAttributes | null =>
  filter ? backboneFilterToFilterAttributes(filter) : null;
